const locations = [
    {
      label: "Whetstone",
      options: [
        { value: "Whetstone", label: "Whetstone" },
        { value: "Mount Chiliad (Whetstone)", label: "Mount Chiliad (Whetstone)" },
        { value: "Angel Pine (Whetstone)", label: "Angel Pine (Whetstone)" },
        { value: "Shady Cabin (Whetstone)", label: "Shady Cabin (Whetstone)" },
        { value: "Shady Creeks (Whetstone)", label: "Shady Creeks (Whetstone)" },
      ],
    },
    {
      label: "Flint County",
      options: [
        { value: "Flint County", label: "Flint County" },
        { value: "The Farm (Flint County)", label: "The Farm (Flint County)" },
        { value: "Beacon Hill (Flint County)", label: "Beacon Hill (Flint County)" },
        { value: "Flint Range (Flint County)", label: "Flint Range (Flint County)" },
        { value: "Flint Intersection (Flint County)", label: "Flint Intersection (Flint County)" },
        { value: "Leafy Hollow (Flint County)", label: "Leafy Hollow (Flint County)" },
        { value: "Back O’ Beyond (Flint County)", label: "Back O’ Beyond (Flint County)" },
        { value: "Los Santos Inlet (Flint County)", label: "Los Santos Inlet (Flint County)" },
      ],
    },
    {
      label: "Los Santos",
      options: [
        { value: "Los Santos", label: "Los Santos" },
        { value: "Mulholland (Los Santos)", label: "Mulholland (Los Santos)" },
        { value: "Richman (Los Santos)", label: "Richman (Los Santos)" },
        { value: "Sunrise (Los Santos)", label: "Sunrise (Los Santos)" },
        { value: "Temple (Los Santos)", label: "Temple (Los Santos)" },
        { value: "Mulholland Intersection (Los Santos)", label: "Mulholland Intersection (Los Santos)" },
        { value: "Las Colinas (Los Santos)", label: "Las Colinas (Los Santos)" },
        { value: "Vinewood (Los Santos)", label: "Vinewood (Los Santos)" },
        { value: "Rodeo (Los Santos)", label: "Rodeo (Los Santos)" },
        { value: "Market Station (Los Santos)", label: "Market Station (Los Santos)" },
        { value: "Market (Los Santos)", label: "Market (Los Santos)" },
        { value: "Marina (Los Santos)", label: "Marina (Los Santos)" },
        { value: "Downtown Los Santos (Los Santos)", label: "Downtown Los Santos (Los Santos)" },
        { value: "Glen Park (Los Santos)", label: "Glen Park (Los Santos)" },
        { value: "Jefferson (Los Santos)", label: "Jefferson (Los Santos)" },
        { value: "East Los Santos (Los Santos)", label: "East Los Santos (Los Santos)" },
        { value: "Los Flores (Los Santos)", label: "Los Flores (Los Santos)" },
        { value: "Commerce (Los Santos)", label: "Commerce (Los Santos)" },
        { value: "Santa Maria Beach (Los Santos)", label: "Santa Maria Beach (Los Santos)" },
        { value: "Verona Beach (Los Santos)", label: "Verona Beach (Los Santos)" },
        { value: "Conference Center (Los Santos)", label: "Conference Center (Los Santos)" },
        { value: "Pershing Square (Los Santos)", label: "Pershing Square (Los Santos)" },
        { value: "Little Mexico (Los Santos)", label: "Little Mexico (Los Santos)" },
        { value: "Idlewood (Los Santos)", label: "Idlewood (Los Santos)" },
        { value: "Ganton (Los Santos)", label: "Ganton (Los Santos)" },
        { value: "East Beach (Los Santos)", label: "East Beach (Los Santos)" },
        { value: "Verdant Bluffs (Los Santos)", label: "Verdant Bluffs (Los Santos)" },
        { value: "Unity Station (Los Santos)", label: "Unity Station (Los Santos)" },
        { value: "El Corona (Los Santos)", label: "El Corona (Los Santos)" },
        { value: "Willowfield (Los Santos)", label: "Willowfield (Los Santos)" },
        { value: "Playa Del Seville (Los Santos)", label: "Playa Del Seville (Los Santos)" },
        { value: "Ocean Docks (Los Santos)", label: "Ocean Docks (Los Santos)" },
        { value: "Los Santos International Airport (Los Santos)", label: "Los Santos International Airport (Los Santos)" },
      ],
    },
    {
      label: "San Fierro",
      options: [
        { value: "San Fierro", label: "San Fierro" },
        { value: "Easter Tunnel (San Fierro)", label: "Easter Tunnel (San Fierro)" },
        { value: "Foster Valley (San Fierro)", label: "Foster Valley (San Fierro)" },
        { value: "Missionary Hill (San Fierro)", label: "Missionary Hill (San Fierro)" },
        { value: "Easter Bay Airport (San Fierro)", label: "Easter Bay Airport (San Fierro)" },
        { value: "Doherty (San Fierro)", label: "Doherty (San Fierro)" },
        { value: "Avispa Country Club (San Fierro)", label: "Avispa Country Club (San Fierro)" },
        { value: "Garcia (San Fierro)", label: "Garcia (San Fierro)" },
        { value: "Ocean Flats (San Fierro)", label: "Ocean Flats (San Fierro)" },
        { value: "Cranberry Station (San Fierro)", label: "Cranberry Station (San Fierro)" },
        { value: "Easter Basin (San Fierro)", label: "Easter Basin (San Fierro)" },
        { value: "City Hall (San Fierro)", label: "City Hall (San Fierro)" },
        { value: "Queens (San Fierro)", label: "Queens (San Fierro)" },
        { value: "Kings (San Fierro)", label: "Kings (San Fierro)" },
        { value: "Hashbury (San Fierro)", label: "Hashbury (San Fierro)" },
        { value: "Santa Flora (San Fierro)", label: "Santa Flora (San Fierro)" },
        { value: "Juniper Hill (San Fierro)", label: "Juniper Hill (San Fierro)" },
        { value: "Chinatown (San Fierro)", label: "Chinatown (San Fierro)" },
        { value: "Downtown (San Fierro)", label: "Downtown (San Fierro)" },
        { value: "Palisades (San Fierro)", label: "Palisades (San Fierro)" },
        { value: "Paradiso (San Fierro)", label: "Paradiso (San Fierro)" },
        { value: "Juniper Hollow (San Fierro)", label: "Juniper Hollow (San Fierro)" },
        { value: "Calton Heights (San Fierro)", label: "Calton Heights (San Fierro)" },
        { value: "Financial (San Fierro)", label: "Financial (San Fierro)" },
        { value: "Battery Point (San Fierro)", label: "Battery Point (San Fierro)" },
        { value: "Esplanade North (San Fierro)", label: "Esplanade North (San Fierro)" },
        { value: "Esplanade East (San Fierro)", label: "Esplanade East (San Fierro)" },
        { value: "Garver Bridge (San Fierro)", label: "Garver Bridge (San Fierro)" },
        { value: "Kincaid Bridge (San Fierro)", label: "Kincaid Bridge (San Fierro)" },
      ],
    },
    {
      label: "Red County",
      options: [
        { value: "Red County", label: "Red County" },
        { value: "Easter Bay Chemicals (Red County)", label: "Easter Bay Chemicals (Red County)" },
        { value: "Fallen Tree (Red County)", label: "Fallen Tree (Red County)" },
        { value: "Flint Waters (Red County)", label: "Flint Waters (Red County)" },
        { value: "Dillimore (Red County)", label: "Dillimore (Red County)" },
        { value: "Hilltop Farms (Red County)", label: "Hilltop Farms (Red County)" },
        { value: "Northstar Rock (Red County)", label: "Northstar Rock (Red County)" },
        { value: "The Panopticon (Red County)", label: "The Panopticon (Red County)" },
        { value: "Blueberry (Red County)", label: "Blueberry (Red County)" },
        { value: "Blueberry Acres (Red County)", label: "Blueberry Acres (Red County)" },
        { value: "Fern Ridge (Red County)", label: "Fern Ridge (Red County)" },
        { value: "Fisher's Lagoon (Red County)", label: "Fisher's Lagoon (Red County)" },
        { value: "Palomino Creek (Red County)", label: "Palomino Creek (Red County)" },
        { value: "Hanky Panky Point (Red County)", label: "Hanky Panky Point (Red County)" },
        { value: "Martin Bridge (Red County)", label: "Martin Bridge (Red County)" },
        { value: "Fallow Bridge (Red County)", label: "Fallow Bridge (Red County)" },
        { value: "Hampton Barns (Red County)", label: "Hampton Barns (Red County)" },
        { value: "Blueberry Island (Red County)", label: "Blueberry Island (Red County)" },
        { value: "Middle Bridge (Red County)", label: "Middle Bridge (Red County)" },
        { value: "Montgomery (Red County)", label: "Montgomery (Red County)" },
        { value: "Montgomery Intersection (Red County)", label: "Montgomery Intersection (Red County)" },
        { value: "The Mako Span (Red County)", label: "The Mako Span (Red County)" },
        { value: "San Andreas Sound (Red County)", label: "San Andreas Sound (Red County)" },
        { value: "Frederick Bridge (Red County)", label: "Frederick Bridge (Red County)" },
        { value: "North Rock (Red County)", label: "North Rock (Red County)" },
      ],
    },
    {
      label: "Tierra Robada",
      options: [
        { value: "Tierra Robada", label: "Tierra Robada" },
        { value: "Gant Bridge (Tierra Robada)", label: "Gant Bridge (Tierra Robada)" },
        { value: "San Fierro Bay (Tierra Robada)", label: "San Fierro Bay (Tierra Robada)" },
        { value: "Bayside (Tierra Robada)", label: "Bayside (Tierra Robada)" },
        { value: "Bayside Marina (Tierra Robada)", label: "Bayside Marina (Tierra Robada)" },
        { value: "Bayside Tunnel (Tierra Robada)", label: "Bayside Tunnel (Tierra Robada)" },
        { value: "El Quebrados (Tierra Robada)", label: "El Quebrados (Tierra Robada)" },
        { value: "Aldea Malvada (Tierra Robada)", label: "Aldea Malvada (Tierra Robada)" },
        { value: "Valle Ocultado (Tierra Robada)", label: "Valle Ocultado (Tierra Robada)" },
        { value: "Arco Del Oeste (Tierra Robada)", label: "Arco Del Oeste (Tierra Robada)" },
        { value: "The Sherman Dam (Tierra Robada)", label: "The Sherman Dam (Tierra Robada)" },
        { value: "Sherman Reservoir (Tierra Robada)", label: "Sherman Reservoir (Tierra Robada)" },
        { value: "Las Barrancas (Tierra Robada)", label: "Las Barrancas (Tierra Robada)" },
        { value: "Robada Intersection (Tierra Robada)", label: "Robada Intersection (Tierra Robada)" },
      ],
    },
    {
      label: "Bone County",
      options: [
        { value: "Bone County", label: "Bone County" },
        { value: "Las Payasadas (Bone County)", label: "Las Payasadas (Bone County)" },
        { value: "Verdant Meadows (Bone County)", label: "Verdant Meadows (Bone County)" },
        { value: "El Castillo del Diablo (Bone County)", label: "El Castillo del Diablo (Bone County)" },
        { value: "Las Brujas El (Bone County)", label: "Las Brujas (Bone County)" },
        { value: "Regular Tom (Bone County)", label: "Regular Tom (Bone County)" },
        { value: "No Fly Zone (Bone County)", label: "No Fly Zone (Bone County)" },
        { value: "The Big Ear (Bone County)", label: "The Big Ear (Bone County)" },
        { value: "Lil' Probe'Inn (Bone County)", label: "Lil' Probe'Inn (Bone County)" },
        { value: "Green Palms (Bone County)", label: "Green Palms (Bone County)" },
        { value: "Octane Springs (Bone County)", label: "Octane Springs (Bone County)" },
        { value: "Fort Carson (Bone County)", label: "Fort Carson (Bone County)" },
        { value: "Hunter Quarry (Bone County)", label: "Hunter Quarry (Bone County)" },
        { value: "Restricted Area (Bone County)", label: "Restricted Area (Bone County)" },
      ],
    },
    {
      label: "Las Venturas",
      options: [
        { value: "Las Venturas", label: "Las Venturas" },
        { value: "Yellow Bell Golf Course (Las Venturas)", label: "Yellow Bell Golf Course (Las Venturas)" },
        { value: "Yellow Bell Station (Las Venturas)", label: "Yellow Bell Station (Las Venturas)" },
        { value: "Prickle Pine (Las Venturas)", label: "Prickle Pine (Las Venturas)" },
        { value: "Spinybed (Las Venturas)", label: "Spinybed (Las Venturas)" },
        { value: "K.A.C.C. Military Fuels (Las Venturas)", label: "K.A.C.C Military Fuels (Las Venturas)" },
        { value: "Julius Thruway North (Las Venturas)", label: "Julius Thruway North (Las Venturas)" },
        { value: "Julius Thruway East (Las Venturas)", label: "Julius Thruway East (Las Venturas)" },
        { value: "Julius Thruway South (Las Venturas)", label: "Julius Thruway South (Las Venturas)" },
        { value: "Julius Thruway West (Las Venturas)", label: "Julius Thruway West (Las Venturas)" },
        { value: "Pilson Intersection (Las Venturas)", label: "Pilson Intersection (Las Venturas)" },
        { value: "The Emerald Isle (Las Venturas)", label: "The Emerald Isle (Las Venturas)" },
        { value: "Roca Escalante (Las Venturas)", label: "Roca Escalante (Las Venturas)" },
        { value: "Creek (Las Venturas)", label: "Creek (Las Venturas)" },
        { value: "Redsands West (Las Venturas)", label: "Redsands West (Las Venturas)" },
        { value: "Whitewood Estates (Las Venturas)", label: "Whitewood Estates (Las Venturas)" },
        { value: "Redsands East (Las Venturas)", label: "Redsands East (Las Venturas)" },
        { value: "Harry Gold Parkway (Las Venturas)", label: "Harry Gold Parkway (Las Venturas)" },
        { value: "The Visage (Las Venturas)", label: "The Visage (Las Venturas)" },
        { value: "Old Venturas Strip (Las Venturas)", label: "Old Venturas Strip (Las Venturas)" },
        { value: "Starfish Casino (Las Venturas)", label: "Starfish Casino (Las Venturas)" },
        { value: "The Clown's Pocket (Las Venturas)", label: "The Clown's Pocket (Las Venturas)" },
        { value: "Blackfield (Las Venturas)", label: "Blackfield (Las Venturas)" },
        { value: "Las Venturas Airport (Las Venturas)", label: "Las Venturas Airport (Las Venturas)" },
        { value: "Pirates in Men's Pants (Las Venturas)", label: "Pirates in Men's Pants (Las Venturas)" },
        { value: "Caligula's Palace (Las Venturas)", label: "Caligula's Palace (Las Venturas)" },
        { value: "Pilgrim (Las Venturas)", label: "Pilgrim (Las Venturas)" },
        { value: "Sobell Rail Yards (Las Venturas)", label: "Sobell Rail Yards (Las Venturas)" },
        { value: "Blackfield College (Las Venturas)", label: "Blackfield College (Las Venturas)" },
        { value: "Blackfield Intersection (Las Venturas)", label: "Blackfield Intersection (Las Venturas)" },
        { value: "LVA Freight Depot (Las Venturas)", label: "LVA Freight Depot (Las Venturas)" },
        { value: "The High Roller (Las Venturas)", label: "The High Roller (Las Venturas)" },
        { value: "The Strip (Las Venturas)", label: "The Strip (Las Venturas)" },
        { value: "Royal Casino (Las Venturas)", label: "Royal Casino (Las Venturas)" },
        { value: "The Camel's Toe (Las Venturas)", label: "The Camel's Toe (Las Venturas)" },
        { value: "Linden Station (Las Venturas)", label: "Linden Station (Las Venturas)" },
        { value: "The Pink Swan (Las Venturas)", label: "The Pink Swan (Las Venturas)" },
        { value: "Come-A-Lot (Las Venturas)", label: "Come-A-Lot (Las Venturas)" },
        { value: "Linden Side (Las Venturas)", label: "Linden Side (Las Venturas)" },
        { value: "Blackfield Chapel (Las Venturas)", label: "Blackfield Chapel (Las Venturas)" },
        { value: "Randolph Industrial Estate (Las Venturas)", label: "Randolph Industrial Estate (Las Venturas)" },
        { value: "Last Dime Motel (Las Venturas)", label: "Last Dime Motel (Las Venturas)" },
        { value: "The Four Dragons Hotel & Casino (Las Venturas)", label: "The Four Dragons Hotel & Casino (Las Venturas)" },
        { value: "Rockshore East (Las Venturas)", label: "Rockshore East (Las Venturas)" },
        { value: "Rockshore West (Las Venturas)", label: "Rockshore West (Las Venturas)" },
        { value: "Greenglass College (Las Venturas)", label: "Greenglass College (Las Venturas)" },
        
      ],
    },
  ];

  export default locations;